import StoreModuleService from '../../../StoreModuleService';
import { initialState } from './state';
import Vue from 'vue';
import cloneDeep from 'lodash/cloneDeep';

// mutations declarations
export const SET_PLACEMENT_VERSION_DATA = 'SET_PLACEMENT_VERSION_DATA';

const mutations = {
	...StoreModuleService.createDefaultMutations({ initializer: initialState }),
	[SET_PLACEMENT_VERSION_DATA](state, { placementId, placementVersion }) {
		const placementVersions = cloneDeep(state.data[placementId]) || {};
		const { version } = placementVersion;
		placementVersions[version] = placementVersion;
		Vue.set(state.data, placementId, placementVersions);
	},
};

export default mutations;
